// src/api/apiService.js
import axios from 'axios';

// Set base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_CMS_BASEURL;


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const getCmsData = () => {
  const endpoint =
    'b2cimgs-and-vdos/?populate=headerComp,firstComp,firstComp.images,secondComp,thirdComp,forthComp,forthComp.image_url,forthComp.videoUrl';
  return api.get(endpoint);
};

export class ApiService {
  static async fetchPatientById(id) {
   
    try {
      const response = await api.get(`${process.env.REACT_APP_QUANTUM_SESSION}aes-sessions/session-info/${encodeURIComponent(id)}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching patient with ID ${id}:`, error);
      throw error;
    }
  }

  // Optional: If you have multiple similar endpoints
  static async fetchByEndpointAndId(endpoint, id) {
    try {
      const response = await api.get(`${endpoint}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching from ${endpoint}/${id}:`, error);
      throw error;
    }
  }
}

export const apiService = ApiService;


